import React from 'react'
import AloIcon from '../../assets/codicons/a'
import PropTypes from 'prop-types'

const EmptyState = ({ caption, link, linkCaption }) => {
  return (
    <div className='row empty-state'>
      <AloIcon />
      <div>
        <h3 className='empty-header'>{caption}</h3>
        <a className='see-more' href={link}>
          {linkCaption}
        </a>
      </div>
    </div>
  )
}

EmptyState.defaultProps = {
  linkCaption: 'Explore our library'
}

EmptyState.propTypes = {
  caption: PropTypes.string,
  link: PropTypes.string,
  linkCaption: PropTypes.string
}

export default EmptyState
